import {
  withCompInfo,
  withUiTypeCompInfo,
  withStateRefs,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type { VectorImageDefinition } from '@wix/thunderbolt-components-native';
import type {
  ClassNameToRootExperiment,
  IVectorImageMapperProps,
  IVectorImageStateRefs,
  IVectorImageUiTypes,
} from '../VectorImage.types';
import type { VectorImageProps } from '@wix/thunderbolt-components';

// ClassNameToRootExperiment & experiment should be removed after the specs.thunderbolt.classNameToRoot is open to 100%
const isExperimentOpen = (experiment: boolean | string) =>
  String(experiment) === 'true';

export const props = withCompInfo<
  IVectorImageMapperProps,
  VectorImageDefinition,
  VectorImageProps & ClassNameToRootExperiment
>()(
  [
    'fullNameCompType',
    'language',
    'mainPageId',
    'compId',
    'trackClicksAnalytics',
    'experiments',
  ],
  (compProps, carmiData) => {
    return {
      ...carmiData,
      ...compProps,
      isClassNameToRootEnabled: isExperimentOpen(
        compProps.experiments['specs.thunderbolt.isClassNameToRootEnabled'],
      ),
    };
  },
);

export const stateRefs = withStateRefs<IVectorImageStateRefs>()(
  ['refApi', 'compBehaviors'],
  ({ refApi, compBehaviors }) => {
    const menuContainerId = compBehaviors?.[0]?.behavior.targetId;

    return {
      reportBi: refApi.businessLogger.reportBi(),
      ...(menuContainerId && {
        toggle: refApi.menuContainer?.toggle(menuContainerId),
      }),
    };
  },
);

export const uiType = withUiTypeCompInfo<
  IVectorImageUiTypes,
  VectorImageDefinition
>()(['compBehaviors'], ({ compBehaviors }) => {
  const hasClickBehavior = compBehaviors[0]?.action.name === 'click';

  return hasClickBehavior ? 'VectorButton' : undefined;
});

export const sdkData = withCompInfo<
  VectorImageProps,
  VectorImageDefinition,
  VectorImageProps
>()(['hasResponsiveLayout'], ({ hasResponsiveLayout }, carmiSdkData) => {
  return {
    isResponsive: hasResponsiveLayout,
    ...carmiSdkData,
  };
});

export default createComponentMapperModel({
  props,
  stateRefs,
  uiType,
  sdkData,
});
